import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const SwgNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="swg" />;
};
